import { useEffect, useState } from "react";
import { getStoredAccessToken } from "api/axios";
import { getLoggedinUser } from "../../helpers/api_helper";

const useProfile = () => {
  const userProfileSession = getLoggedinUser();
  const token = getStoredAccessToken();
  const [loading, setLoading] = useState(
    userProfileSession && token ? false : true
  );
  const [userProfile, setUserProfile] = useState(
    userProfileSession ? userProfileSession : null
  );

  useEffect(() => {
    const session = getLoggedinUser();
    const access = getStoredAccessToken();
    setUserProfile(session ? session : null);
    setLoading(session && access ? false : true);
  }, []);

  return { userProfile, loading, token };
};

export { useProfile };
